import styled from 'styled-components';

export const Container = styled.label`
	min-width: 225px;
	width: calc(50% - 30px);
	height: 190px;
	margin-bottom: 30px;
	padding: 0 15px;
`;

interface ControlWrapProps {
	valid: boolean
};

export const ControlWrap = styled.div<ControlWrapProps>`
	position: relative;
	display: flex;
	flex-flow: column;
	justify-content: center;
	height: 100%;
	border: 2px solid ${(props) => props.valid ? '#1d1d1d' : '#D3350D'};
	border-radius: 8px;
	box-shadow: ${(props) => props.valid ? 'none' : '-2px 2px 5px 2px rgba(211, 53, 13, 0.2)'};
	font-weight: bold;
	font-size: 1rem;
	text-align: center;
	color: #333;
	transition: opacity 0.1s ease-in;
	text-transform: capitalize;
`;

export const Check = styled.div`
	position: absolute;
	top: 15px;
	right: 15px;
	width: 20px;
	height: 20px;
	border-radius: 100%;
	border: 1px solid #1d1d1d;
	color: #fff;
`;

export const Radio = styled.input`
	clip: rect(0 0 0 0);
	-webkit-clip-path: inset(50%);
	clip-path: inset(50%);
	height: 1px;
	overflow: hidden;
	position: absolute;
	white-space: nowrap;
	width: 1px;
	&:checked {
		+ ${ControlWrap} {
			box-shadow: -2px -2px 5px 2px rgba(29, 29, 29, 0.2);
			${Check} {
				background-color: #1d1d1d;
			}
		}
	}
`;

export const ControlLabel = styled.div`
	font-weight: 500;
	font-size: 1.2rem;
	text-transform: capitalize;
`;
